import React, { Suspense, useEffect, useMemo, useRef, useState } from "react";
import {
  Mail,
  PhoneCall,
  Copy,
  Pencil,
  Calendar,
  Clock,
  User,
  Plus,
  CopyCheck,
  PlusIcon,
  Settings2,
  PanelRight,
  Power,
  X,
  Trash2,
} from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import moment from "moment/moment";
import { Alert, Snackbar } from "@mui/material";
import Tooltip from "../../../../component/ui/tooltip";
// import FilesTab from "../../../../component/files";
import Style from "./style.module.css";
import CommentsSection from "../../../../component/comment";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import EmployeeDirectoryAddUpdate from "../../../organization/emplyee-directory/add-update";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import { TableCard } from "../../../../component/table/table-layout";
import CustomizeTabsOverviewPopup from "./component/customize-tabs-popup";
import DotsVerticalIcon from "../../../../component/icons/dots-vertical";
import { RightSidebar } from "./component/right-side-bar";
import ConvertLeadToDeal from "../../../../component/modals/convert-lead/convert-lead-to-deal";
import Swal from "sweetalert2";
import Avatar from "../../../../component/ui/avatar";
import AvatarProfile from "../../../../component/ui/profile";
import { useClickOutside } from "../../../../component/custom-hooks/click-outside";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import capitalizeWords from "../../../../component/custom-hooks/capitalizeWords";
import Icon from "../../../../component/icons/inner-pages-icons";
// import CommentsSection from "../../../mainDeals/detail-Page/all-details/component/comments";
import FilesTab from "../../../mainDeals/detail-Page/all-details/component/files";
import FollowUpPopup from "../../../mainDeals/detail-Page/follow-ups";
import { FollowUpsTab, TimelineTab } from "../../../../component/ui/timeline";

const Chip2 = ({ label, tone = "info" }) => {
  const toneMap = {
    success: "bg-emerald-50 text-emerald-700 ring-emerald-200",
    danger: "bg-rose-50 text-rose-700 ring-rose-200",
    warning: "bg-amber-50 text-amber-700 ring-amber-200",
    info: "bg-sky-50 text-sky-700 ring-sky-200",
  };
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full  px-2.5 py-[3px] text-[11px] font-medium ring-1 ${toneMap[tone]}`}
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${
          tone === "success"
            ? "bg-emerald-500"
            : tone === "danger"
              ? "bg-rose-500"
              : tone === "warning"
                ? "bg-amber-500"
                : "bg-sky-500"
        }`}
      />
      {label}
    </span>
  );
};

const CopyIcon = ({ text }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <>
      <div
        className="ms-2 hover:opacity-50 cursor-pointer transition-all"
        onClick={() => {
          copyToClipboard(text);
        }}
      >
        {isCopied ? (
          <CopyCheck size={15} color="#333" />
        ) : (
          <Copy size={15} color="#333" />
        )}
      </div>
    </>
  );
};

function NewField({ label, value, icon: Icon }) {
  const [isActive, setIsActive] = useState(false);
  const isUrl =
    typeof value === "string" &&
    (value.startsWith("http://") || value.startsWith("https://"));
  const [showAll, setShowAll] = useState(false);

  const limit = 70;
  const isLongText = value?.length > limit;

  const displayText =
    !isLongText || showAll ? value : value.slice(0, limit) + "...";
  return (
    <div>
      {isUrl ? (
        <>
          <div className="flex flex-col gap-y-[10px]">
            <div className="flex gap-[10px] items-center">
              {Icon ? (
                <span>{Icon ? <Icon size={16} /> : <User size={16} />} </span>
              ) : null}
              <p className="text-xs font-medium">{label}</p>
            </div>

            <div className="flex justify-between text-[14px] w-full font-normal text-[#999] min-w-0">
              <a
                href={value}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:underline break-all whitespace-normal min-w-0"
              >
                {value?.length > 50 ? `${value?.slice(0, 30)}...` : value}
              </a>

              <CopyIcon text={value} />
            </div>
          </div>
        </>
      ) : (
        <div className="flex flex-col gap-y-[10px]">
          <div className="flex gap-[10px] items-center">
            {Icon ? (
              <span>{Icon ? <Icon size={16} /> : <User size={16} />} </span>
            ) : null}
            <p className="text-xs font-medium">{label}</p>
          </div>

          {/* <div className="text-sm font-medium text-[rgba(14,18,27,0.40)]">
            {value}
          </div> */}
          {/* Value */}
          <div className="text-sm font-medium text-[rgba(14,18,27,0.40)] break-words whitespace-normal ">
            {displayText}

            {isLongText && (
              <button
                onClick={() => setShowAll(!showAll)}
                className="ml-1 text-[#0057FB] text-xs font-medium hover:underline"
              >
                {showAll ? "Show less" : "Show more"}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const T = {
  bg: "#EDE8E1",
  sidebar: "#1a1730",
  sidebarHover: "#252240",
  sidebarActive: "#302d4a",
  card: "#FFFFFF",
  cardBorder: "rgba(0,0,0,0.08)",
  text: "#1a1520",
  textSecondary: "#5c5466",
  textMuted: "#908892",
  accent: "#6366f1",
  accentLight: "rgba(99,102,241,0.08)",
  accentText: "#5457e5",
  shadow: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
  shadowMd: "0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)",
  shadowLg: "0 8px 30px rgba(0,0,0,0.08)",
  inputBg: "#F3EFE9",
  inputBorder: "rgba(0,0,0,0.1)",
};

const STATUS_COLORS = {
  "Need Analysis": "#f59e0b",
  "Value Proposition": "#3b82f6",
  "Identify Decision": "#8b5cf6",
  Proposal: "#06b6d4",
  Review: "#10b981",
  "Closed Won": "#22c55e",
  Won: "#22c55e",
  "Closed Lost": "#ef4444",
  Lost: "#ef4444",
};

const ProjectStatusHEX = {
  pending: "#b45309", // amber-700
  in_progress: "#1d4ed8", // blue-700
  revision: "#6b21a8", // purple-700
  on_hold: "#be123c", // rose-700
  completed: "#047857", // emerald-700
};

const STAGES = [
  "Need Analysis",
  "Value Proposition",
  "Identify Decision",
  "Proposal",
  "Review",
];

// ─── HELPERS ───
const activityIcons = {
  call: "phone",
  phone: "phone",
  email: "mail",
  sms: "sms",
  consultation: "consultation",
  default: "default",

  note: "note",
  meeting: "calendar",
  "follow-up": "calendar",
  followup: "calendar",
  stage: "arrowRight",
  voicemail: "mic",
  chat: "sms",
  comment: "sms",
  demo: "demo",
  messasge: "sms",
  presentation: "presentation",
  assign: "assign",
  unassign: "unassign",
  file: "file",
  brief: "brief",
};

const activityColors = {
  call: "#3b82f6", // blue
  email: "#8b5cf6", // violet
  sms: "#06b6d4", // cyan
  consultation: "#f59e0b", // amber
  note: "#f59e0b", // amber
  meeting: "#10b981", // emerald
  stage: "#6366f1", // indigo
  // "follow-up": "#6366f1", // indigo
  "follow-up": "#06b6d4", // indigo
  voicemail: "#ef4444", // red

  chat: "#0ea5e9", // sky blue
  presentation: "#14b8a6", // teal
  demo: "#a855f7", // purple
  default: "#a855f7", // purple
  messasge: "#f43f5e", // rose

  // remaining icons (added)
  phone: "#3b82f6", // blue
  comment: "#0ea5e9", // sky
  followup: "#06b6d4", // indigo
  assign: "#22c55e", // green
  unassign: "#ef4444", // red
  file: "#eab308", // slate
  brief: "#eab308", // yellow
};
const priorityColors = { high: "#ef4444", medium: "#f59e0b", low: "#10b981" };

const LeadStatus = {
  // lead
  active: { background: "#ede9fe", color: "#5b21b6" }, // emerald green
  // emerald green
  "new lead": { background: "#dbeafe", color: "#1A73E8" }, // royal blue
  pending: { background: "#fff3e0", color: "#e65100" }, // deep orange
  voicemail: { background: "#e0f2fe", color: "#0369a1" }, // violet
  attempted: { background: "#c7d2fe", color: "#3730a3" }, // strong red

  // deal
  won: { background: "#e8f5e9", color: "#388e3c" }, // emerald green
  interested: { background: "#e8f5e9", color: "#388e3c" }, // emerald green
  "closed won": { background: "#e8f5e9", color: "#388e3c" }, // emerald green
  "need analysis": { background: "#E8F0FE", color: "#1A73E8" }, // royal blue
  proposal: { background: "#fff3e0", color: "#e65100" }, // deep orange
  "identify decision": { background: "#F3E8FF", color: "#9333EA" }, // violet
  lost: { background: "#fee2e2", color: "#b91c1c" }, // strong red
  "closed lost": { background: "#fee2e2", color: "#b91c1c" }, // strong red
  "value proposition": { background: "#E0F7FA", color: "#00838F" }, // cyan / teal
  review: { background: "#F5F5DC", color: "#6D4C41" }, // brown / sand

  // project
  completed: { background: "#E6F9F0", color: "#0F9D58" }, // emerald green
  on_hold: { background: "#E8F0FE", color: "#1A73E8" }, // royal blue
  pending: { background: "#fff3e0", color: "#e65100" }, // deep orange
  in_progress: { background: "#F3E8FF", color: "#9333EA" }, // violet
  revision: { background: "#E0F7FA", color: "#00838F" }, // cyan / teal
  "no answer update 2": { background: "#f3f4f6", color: "#374151" }, // cyan / teal
  "wrong number": { background: "#fee2e2", color: "#b91c1c" }, // cyan / teal
  "call back": { background: "#fffbeb", color: "#78350f" }, // cyan / teal
  "not interested": { background: "#fee2e2", color: "#b91c1c" }, // cyan / teal
  "do not contact": { background: "#f9fafb", color: "#374151" }, // cyan / teal
  duplicate: { background: "#ede9fe", color: "#5b21b6" },
};

// ─── COMPONENTS ───

const Badge = ({ color, children, style = {} }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      padding: "3px 10px",
      borderRadius: 6,
      fontSize: 11,
      fontWeight: 600,
      background: color + "14",
      color,
      letterSpacing: "0.3px",
      ...style,
    }}
  >
    {children}
  </span>
);

const Card = ({ children, style = {}, hover = false, onClick }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => hover && setHovered(true)}
      onMouseLeave={() => hover && setHovered(false)}
      style={{
        background: T.card,
        border: `1px solid ${T.cardBorder}`,
        borderRadius: 12,
        boxShadow: hovered ? T.shadowMd : T.shadow,
        transform: hovered ? "translateY(-1px)" : "none",
        transition: "all 0.15s ease",
        cursor: onClick ? "pointer" : "default",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

const ActionButton = ({
  icon,
  label,
  color = T.accent,
  variant = "outline",
  onClick,
  style = {},
}) => {
  const [hovered, setHovered] = useState(false);
  const filled = variant === "filled";
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "10px 16px",
        borderRadius: 10,
        border: filled ? "none" : `1px solid ${color}30`,
        background: filled
          ? hovered
            ? color
            : color + "ee"
          : hovered
            ? color + "10"
            : color + "06",
        color: filled ? "#fff" : color,
        cursor: "pointer",
        fontSize: 13,
        fontWeight: 600,
        fontFamily: "inherit",
        transition: "all 0.15s",
        width: "100%",
        boxShadow: filled ? `0 2px 8px ${color}35` : "none",
        ...style,
      }}
    >
      <Icon name={icon} size={15} color={filled ? "#fff" : color} /> {label}
    </button>
  );
};

const getInitials = (name = "") => {
  return name
    .trim()
    .split(/\s+/)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
};

function NewMetaField({ label, value }) {
  const isUrl =
    typeof value === "string" &&
    (value.startsWith("http://") || value.startsWith("https://"));
  const [showAll, setShowAll] = useState(false);

  const limit = 70;
  const isLongText = value?.length > limit;

  const displayText =
    !isLongText || showAll ? value : value.slice(0, limit) + "...";
  return isUrl ? (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 0",
          borderBottom:
            // i < 6 ? `1px solid ${T.cardBorder}` : "none",
            `1px solid ${T.cardBorder}`,
        }}
      >
        <div style={{ fontSize: 12, color: T.textMuted }}>{label}</div>

        <div className="flex justify-between font-mono text-[13px]  font-medium text-[#1a1520] min-w-0">
          <a
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:underline break-all whitespace-normal min-w-0"
          >
            {value?.length > 50 ? `${value?.slice(0, 30)}...` : value}
          </a>

          <CopyIcon text={value} />
        </div>
      </div>
    </>
  ) : (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 0",
        borderBottom:
          // i < 6 ? `1px solid ${T.cardBorder}` : "none",
          `1px solid ${T.cardBorder}`,
      }}
    >
      <div style={{ fontSize: 12, color: T.textMuted }}>{label}</div>

      {/* Value */}
      <div className="text-[13px]  font-medium text-[#1a1520] break-words whitespace-normal">
        {displayText || "-"}

        {isLongText && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="ml-1 text-[#0057FB] text-xs font-medium hover:underline"
          >
            {showAll ? "Show less" : "Show more"}
          </button>
        )}
      </div>
    </div>
  );
}

const Details = ({ leadDetail }) => {
  const campaignKeys = [
    "parent_url",
    "user_agent",
    "campaigned",
    "is_dropoff",
    "adgroupid",
    "keyword",
    "device",
    "matchtype",
    "msclkid",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "gclid",
  ];

  const excludeKeys = [
    "name",
    "email",
    "phone",
    "lead_source",
    "leadstatus",
    "leadtime",
    "country",
    "date",
    "signuptime",
    "lead_converted_time",
  ];

  const campaignMeta = leadDetail?.meta?.filter((m) =>
    campaignKeys.includes(m.meta_key),
  );

  const otherMeta = leadDetail?.meta?.filter(
    (m) =>
      !campaignKeys.includes(m.meta_key) && !excludeKeys.includes(m.meta_key),
  );
  return (
    <>
      {/* Additonal  Information */}

      <div className="flex flex-col gap-y-[17px]">
        {/* <div className="bg-white   p-5 rounded-[10px] border border-[#E1E4EA]">
          
          <div className="flex flex-col gap-y-[10px]">
            <div className="flex justify-between items-center">
              <p className="text-xl font-medium leading-normal">Lead Details</p>
            </div>

            <div className="grid grid-cols-3 gap-[15px] ">
              <div className="py-[17px] flex flex-col gap-y-[34px] col-span-1">
                <NewField
                  label="Lead Source"
                  value={leadDetail?.leadsource || "-"}
                />

                <NewField
                  label="Lead Type"
                  value={capitalizeWords(leadDetail?.leadtype) || "-"}
                />
                <NewField
                  label="Created At"
                  value={leadDetail?.leadtime || "-"}
                />
              </div>

              <div className="py-[17px] flex flex-col gap-y-[34px] col-span-1">
                <NewField
                  label="Product Name"
                  value={leadDetail?.product_name || "-"}
                />
                <NewField
                  label="Brand Name"
                  value={leadDetail?.lead_brand?.brandname || "-"}
                />
                
              </div>
            </div>
          </div>
        </div>

        {campaignMeta?.length > 0 || otherMeta?.length > 0 ? (
          <>
            
            <div className="bg-white   p-5 rounded-[10px] border border-[#E1E4EA]">
           
              <div className="flex flex-col gap-y-[10px]">
                
                <div className="flex justify-between items-center">
                  <p className="text-xl font-medium leading-normal">
                    Other Information
                  </p>

                  
                </div>

                <div>
                  {campaignMeta?.length > 0 && (
                    <div className="grid gap-[15px] grid-cols-3">
                      {campaignMeta.map((st, i) => (
                        <div className="col-span-1 min-w-0">
                          <NewField
                            key={i}
                            label={st.meta_key
                              .replaceAll("_", " ")
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                            value={st.meta_value || "-"}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div>
                  {otherMeta?.length > 0 && (
                    <div className="grid gap-[15px] grid-cols-3">
                      {otherMeta.map((st, i) => (
                        <div className="col-span-1 min-w-0">
                          <NewField
                            key={i}
                            label={st.meta_key
                              .replaceAll("_", " ")
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                            value={st.meta_value || "-"}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : null} */}

        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}
        >
          <Card style={{ padding: 20, maxHeight: "350px", overflow: "auto" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 16,
              }}
            >
              <span style={{ fontSize: 14, fontWeight: 700 }}>
                Lead Details
              </span>
            </div>
            {[
              { label: "Name", value: leadDetail?.name || "-" },

              {
                label: "Email",
                value: leadDetail?.email || "-",
                action: true,
                isUrl: true,
                url: `mailto:${leadDetail?.email}`,
              },
              {
                label: "Phone",
                value: leadDetail?.phone || "-",
                action: true,
                isUrl: true,
                url: `tel:${leadDetail?.phone}`,
              },
              { label: "Product Name", value: leadDetail?.product_name || "-" },
              { label: "Brand Name", value: leadDetail?.lead_brand?.brandname },
              {
                label: "Lead Type",
                value: capitalizeWords(leadDetail?.leadtype) || "-",
              },
              { label: "Lead Source", value: leadDetail?.leadsource || "-" },
              { label: "Date Created", value: leadDetail?.leadtime || "-" },
              {
                /* TemporaryHide */
              },
              // {/* <NewField label="Service" value={leadDetail?.service || "-"} /> */},
            ].map((field, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 0",
                  borderBottom: i < 6 ? `1px solid ${T.cardBorder}` : "none",
                }}
              >
                <span style={{ fontSize: 12, color: T.textMuted }}>
                  {field.label}
                </span>
                {field.badge ? (
                  <Badge color={field.color}>{field.value}</Badge>
                ) : (
                  <span
                    style={{
                      fontSize: 13,
                      fontWeight: field.highlight ? 700 : 500,
                      color: field.highlight
                        ? "#22c55e"
                        : field.action
                          ? T.accentText
                          : T.text,
                      fontFamily: field.mono ? "monospace" : "inherit",
                      fontSize: field.mono ? 11 : 13,
                    }}
                  >
                    {field?.isUrl ? (
                      <a href={field?.url}>{field?.value}</a>
                    ) : (
                      field.value
                    )}
                  </span>
                )}
              </div>
            ))}
          </Card>
          {campaignMeta?.length > 0 || otherMeta?.length > 0 ? (
            <>
              {/* Other Information */}

              <Card
                style={{
                  padding: 20,
                  maxHeight: "350px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 16,
                  }}
                >
                  <span style={{ fontSize: 14, fontWeight: 700, zIndex: "10" }}>
                    Additional Information
                  </span>
                </div>
                <div
                  className="w-full h-full overflow-auto  [scrollbar-width:none]
        [&::-webkit-scrollbar]:hidden
        [&_*::-webkit-scrollbar]:hidden
        [&_*]:[scrollbar-width:none]"
                  style={{
                    scrollbarGutter: "stable",
                    // paddingRight: "4px",
                  }}
                >
                  {campaignMeta?.length > 0
                    ? campaignMeta?.map((field, i) => (
                        <NewMetaField
                          key={i}
                          label={field.meta_key
                            .replaceAll("_", " ")
                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                          value={field?.meta_value}
                        />
                      ))
                    : null}
                  {otherMeta?.length > 0 &&
                    otherMeta?.map((field, i) => {
                      return (
                        <>
                          <NewMetaField
                            key={i}
                            label={field.meta_key
                              .replaceAll("_", " ")
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                            value={field?.meta_value}
                          />
                        </>
                      );
                    })}
                </div>
              </Card>
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};

const CommentsTab = ({ leadDetail, updateCount = () => {} }) => {
  return (
    <div className="w-full !h-full overflow-auto relative">
      <div className="space-y-4 !h-full">
        <CommentsSection
          type="lead"
          id={leadDetail.leadid}
          apiBaseUrl="lead"
          title="true"
          updateCount={updateCount}
          data={leadDetail}
          HasPopupUi={false}
        />
      </div>
    </div>
  );
};

// const TimelineTab = ({
//   leadDetail,
//   UsersList = [],
//   onSubmit = () => {},
//   onError = () => {},
// }) => {
//   const [showActivityModal, setShowActivityModal] = useState(false);
//   const [selectedActivity, setSelectedActivity] = useState(null);
//   const [type, setType] = useState("");

//   return (
//     <>
//       <div>
//         {leadDetail?.activities?.length ? (
//           <>
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: 0,
//                 position: "relative",
//               }}
//             >
//               {/* Quick log bar */}

//               <Card
//                 style={{
//                   padding: "12px 16px",
//                   marginBottom: 12,
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 8,
//                 }}
//               >
//                 <span
//                   style={{ fontSize: 12, color: T.textMuted, fontWeight: 500 }}
//                 >
//                   Quick log:
//                 </span>

//                 {[
//                   "Call",
//                   "Meeting",
//                   "Email",
//                   "Follow-up",
//                   "Demo",
//                   "Chat",
//                   "Consultation",
//                   "Presentation",
//                 ].map((type) => (
//                   <button
//                     key={type}
//                     onClick={() => {
//                       if (typeof setSelectedActivity === "function") {
//                         setSelectedActivity(null);
//                         setType(type);
//                         console.log("type", type);
//                       }
//                       if (typeof setShowActivityModal === "function") {
//                         setShowActivityModal(true);
//                         setType(type);
//                       }
//                     }}
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 5,
//                       padding: "5px 12px",
//                       borderRadius: 20,
//                       border: `1px solid ${activityColors[type?.toLocaleLowerCase() || "default"]}25`,
//                       background:
//                         activityColors[type?.toLocaleLowerCase()] + "08",
//                       color: activityColors[type?.toLocaleLowerCase()],
//                       cursor: "pointer",
//                       fontSize: 11,
//                       fontWeight: 600,
//                       fontFamily: "inherit",
//                     }}
//                   >
//                     <Icon
//                       name={
//                         activityIcons[type?.toLocaleLowerCase() || "default"]
//                       }
//                       size={12}
//                       color={
//                         activityColors[type?.toLocaleLowerCase() || "default"]
//                       }
//                     />
//                     {type.charAt(0).toUpperCase() + type.slice(1)}
//                   </button>
//                 ))}
//               </Card>

//               {/* Timeline items */}
//               <div style={{ position: "relative", paddingLeft: 28 }}>
//                 {/* Vertical line */}
//                 <div
//                   style={{
//                     position: "absolute",
//                     left: 11,
//                     // top: 8,
//                     // bottom: 8,
//                     top: 15,
//                     bottom: 40,
//                     width: 2,
//                     background: "#ddd8d2",
//                     borderRadius: 1,
//                   }}
//                 />

//                 {leadDetail?.activities?.map((a, i) => {
//                   const color =
//                     activityColors[a?.icon?.toLocaleLowerCase()] ||
//                     "#8b5cf6" ||
//                     "#6b7280";
//                   return (
//                     <div
//                       key={a.id}
//                       style={{ position: "relative", marginBottom: 8 }}
//                     >
//                       {/* Dot */}
//                       <div
//                         style={{
//                           position: "absolute",
//                           left: -22,
//                           top: 16,
//                           width: 12,
//                           height: 12,
//                           borderRadius: "50%",
//                           background: color + "20",
//                           border: `2.5px solid ${color}`,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           zIndex: 1,
//                         }}
//                       >
//                         <div
//                           style={{
//                             width: 4,
//                             height: 4,
//                             borderRadius: "50%",
//                             background: color,
//                           }}
//                         />
//                       </div>

//                       <Card hover style={{ padding: "14px 18px" }}>
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "flex-start",
//                             gap: 12,
//                           }}
//                         >
//                           <div
//                             style={{
//                               width: 32,
//                               height: 32,
//                               borderRadius: 8,
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               background: color + "12",
//                               flexShrink: 0,
//                             }}
//                           >
//                             <Icon
//                               name={
//                                 activityIcons[
//                                   a?.icon?.toLocaleLowerCase() || "default"
//                                 ]
//                               }
//                               size={14}
//                               color={color}
//                             />
//                             {/* <div
//                             style={{
//                               width: 32,
//                               height: 32,
//                               borderRadius: 14,
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               background: `linear-gradient(135deg, ${T.accent}, #8b5cf6)`,
//                               color: "#fff",
//                               fontSize: 18,
//                               fontWeight: 700,
//                               flexShrink: 0,
//                             }}
//                           >
//                             {getInitials(a.user.name) || "U"}
//                           </div> */}
//                           </div>
//                           <div style={{ flex: 1, minWidth: 0 }}>
//                             <div
//                               style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "space-between",
//                                 gap: 8,
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 13,
//                                   fontWeight: 600,
//                                   color: T.text,
//                                 }}
//                               >
//                                 {a.log}
//                               </span>
//                             </div>
//                             <div
//                               style={{
//                                 display: "flex",
//                                 gap: 12,
//                                 marginTop: 5,
//                                 fontSize: 11,
//                                 color: T.textMuted,
//                               }}
//                             >
//                               <span>{a?.logtime}</span>
//                               <span>by {a.user.name}</span>
//                               {/* {a.duration && <span>{a.duration}</span>} */}
//                             </div>
//                           </div>
//                         </div>
//                       </Card>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </>
//         ) : (
//           <p className="text-gray-400 text-sm italic text-center">
//             No timeline available.
//           </p>
//         )}
//       </div>

//       {showActivityModal && (
//         <FollowUpPopup
//           onClose={() => {
//             setShowActivityModal(false);
//             setSelectedActivity({});
//           }}
//           CustomerData={selectedActivity}
//           tabIndex={2}
//           onError={onError}
//           onSubmit={onSubmit}
//           id={leadDetail?.leadid}
//           entitytype="lead"
//           entityname={leadDetail.name}
//           UsersList={UsersList}
//           type={type.toLowerCase()}
//         />
//       )}
//     </>
//   );
// };

// const FollowUpsTab = ({ leadDetail, onError, onSubmit, UsersList = [] }) => {
//   const [showActivityModal, setShowActivityModal] = useState(false);
//   const [selectedActivity, setSelectedActivity] = useState(null);
//   return (
//     <>
//       <div className=" flex flex-col gap-[10px]  w-full h-full overflow-auto">
//         <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//           <Card
//             style={{
//               padding: "12px 16px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//             }}
//           >
//             <span style={{ fontSize: 13, fontWeight: 600 }}>
//               Scheduled Follow-Ups
//             </span>
//             <ActionButton
//               icon="plus"
//               label="New Follow-Up"
//               variant="filled"
//               style={{ width: "auto", padding: "7px 14px", fontSize: 12 }}
//               onClick={() => {
//                 if (typeof setSelectedActivity === "function") {
//                   setSelectedActivity(null);
//                 }
//                 if (typeof setShowActivityModal === "function") {
//                   setShowActivityModal(true);
//                 }
//               }}
//             />
//           </Card>
//           {leadDetail?.schedules?.length ? (
//             leadDetail?.schedules?.map((f) => (
//               <Card
//                 key={f.id}
//                 hover
//                 style={{ padding: "14px 18px" }}
//                 onClick={() => {
//                   setSelectedActivity(f);
//                   setShowActivityModal(true);
//                 }}
//               >
//                 <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
//                   <div
//                     style={{
//                       width: 10,
//                       height: 10,
//                       borderRadius: "50%",
//                       background:
//                         f.status?.toLowerCase() === "completed"
//                           ? "#22c55e"
//                           : priorityColors[f.priority],
//                       boxShadow:
//                         f.status?.toLowerCase() === "completed"
//                           ? "none"
//                           : `0 0 0 3px ${priorityColors[f.priority]}20`,
//                     }}
//                   />
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 13,
//                         fontWeight: 600,
//                         color: T.text,
//                         textDecoration:
//                           f.status.toLowerCase() === "completed"
//                             ? "line-through"
//                             : "none",
//                         opacity: f.status === "completed" ? 0.6 : 1,
//                       }}
//                     >
//                       {f?.note}
//                     </div>
//                     <div
//                       style={{
//                         display: "flex",
//                         gap: 12,
//                         marginTop: 4,
//                         fontSize: 11,
//                         color: T.textMuted,
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                         }}
//                       >
//                         <Icon name="calendar" size={11} color={T.textMuted} />{" "}
//                         {f?.due_date}
//                       </span>
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                         }}
//                       >
//                         <Icon name="clock" size={11} color={T.textMuted} />{" "}
//                         {f?.due_time}
//                       </span>
//                     </div>
//                   </div>
//                   <Badge color={priorityColors[f.priority]}>{f.priority}</Badge>
//                 </div>
//               </Card>
//             ))
//           ) : (
//             <p className="text-gray-400 text-sm italic text-center">
//               No scheduled activities.
//             </p>
//           )}
//         </div>

//         {/* ✅ Modal Integration */}
//         {showActivityModal && (
//           // <EmployeeDirectoryAddUpdate
//           //   onClose={() => {
//           //     setShowActivityModal(false);
//           //     setSelectedActivity({});
//           //   }}
//           //   data={selectedActivity}
//           //   tabIndex={2}
//           //   onError={onError}
//           //   onSubmit={onSubmit}
//           //   id={leadDetail.leadid}
//           //   entitytype="lead"
//           //   entityname={leadDetail?.name}
//           // />

//           <FollowUpPopup
//             onClose={() => {
//               setShowActivityModal(false);
//               setSelectedActivity({});
//             }}
//             CustomerData={selectedActivity}
//             tabIndex={2}
//             onError={onError}
//             onSubmit={onSubmit}
//             id={leadDetail?.leadid}
//             entitytype="lead"
//             entityname={leadDetail.name}
//             UsersList={UsersList}
//           />
//         )}
//       </div>
//     </>
//   );
// };

export default function LeadDetailMain({}) {
  const { state } = useLocation();

  const { id, condition2, followUpID } = useParams();
  const [leadDetail, setLeadDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [menuOpen, setMenuOpen] = useState(false);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [rightSidebarOpen, setRightSidebarOpen] = useState(true);
  const [dealCardOpen, setDealCardOpen] = useState(false);
  const [projectCardOpen, setProjectCardOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [search, setSearch] = useState("");
  const [productionUsers, setProductionUsers] = useState([]);
  const [UsersList, setUsersList] = useState([]);
  const [showLogModal, setShowLogModal] = useState(false);
  const [logType, setLogType] = useState("call");

  const apiCall = useApiCall();

  const getData = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `leads/get-lead/${id}`,
      });
      setLeadDetail(res?.data);
      console.log("Lead Detail", res.data);

      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };
  useEffect(() => {
    getData();
  }, [id]);

  const fetchUsers = async () => {
    if (loadingUsers) return;
    setLoadingUsers(true);

    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      console.log("Users API Response ===>", res);
      setProductionUsers(res?.agents || []);
      setUsersList(res?.agents || []);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const updateCount = (updateData) => {
    setLeadDetail(updateData);
  };

  const [showEditModal, setShowEditModal] = useState(false); //
  const [currentData, setCurrentData] = useState({}); //
  const [DealStages, setDealStages] = useState([]); //
  const [Products, setProducts] = useState([]); //
  const [packages, setPackages] = useState([]); //
  const [PackageList, setPackageList] = useState([]);
  const [showLead, setShowLead] = useState(false);
  const [subProducts, setSubProducts] = useState([]);
  const [Menu, showMenu] = useState(false);
  const [statusList, setStatusList] = useState(false);

  const [showConvertModal, setShowConvertModal] = useState(false);
  const navigate = useNavigate();

  const convertLeadSuccess = () => {
    setShowConvertModal(false);
    navigate("/leads/my-leads/lead", { replace: true });
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const updateSuccess = (message) => {
    getData();
    setAlertData({ isShow: true, type: "success", message: message });
    setShowActivityModal(false);
    setShowEditModal(false);
    setCurrentData({});
  };

  const updateError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const DealStage = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `dealstages/deal-stages-list`,
      });

      // filter out "Won" and "Lost"
      const filteredStages = res.data.filter(
        (stage) => stage.name !== "Won" && stage.name !== "Lost",
      );

      setDealStages(filteredStages);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getLeadStatus = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "get-dropdown-list",
      });
      console.log("res?.data", res?.data);

      setStatusList(res?.data?.lead_status || []);
    } catch (error) {
      console.warn("Error fetching Package:", error);
    }
  };

  useEffect(() => {
    DealStage();
    getLeadStatus();
    fetchUsers();
  }, []);

  const editLeadDetails = () => {
    setShowEditModal(true);
    setMenuOpen(false);
    setCurrentData(leadDetail);
  };

  const ConvertDeal = () => {
    setShowConvertModal(true);
  };

  const TabButton = ({ active, label, count, onClick }) => {
    const [hovered, setHovered] = useState(false);
    return (
      <button
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          padding: "8px 16px",
          borderRadius: 8,
          border: "none",
          background: active
            ? T.accent
            : hovered
              ? "rgba(0,0,0,0.04)"
              : "transparent",
          color: active ? "#fff" : hovered ? T.text : T.textSecondary,
          cursor: "pointer",
          fontSize: 13,
          fontWeight: active ? 600 : 500,
          fontFamily: "inherit",
          transition: "all 0.15s",
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        {label}
        {count != undefined && (
          <span
            style={{
              background: active
                ? "rgba(255,255,255,0.25)"
                : "rgba(0,0,0,0.06)",
              padding: "1px 7px",
              borderRadius: 10,
              fontSize: 11,
              fontWeight: 600,
              color: active ? "#fff" : T.textMuted,
            }}
          >
            {count}
          </span>
        )}
      </button>
    );
  };

  const TAB_CONFIG = [
    {
      key: "timeline",
      label: "Timeline",
      component: (
        <TimelineTab
          leadDetail={leadDetail}
          UsersList={UsersList}
          onSubmit={updateSuccess}
          onError={onError}
          condition="lead"
        />
      ),
      count: leadDetail?.activities_count,
    },
    {
      key: "details",
      label: "Details",
      component: <Details leadDetail={leadDetail} />,
    },
    {
      key: "followups",
      label: "Follow ups",
      component: (
        <FollowUpsTab
          leadDetail={leadDetail}
          onSubmit={updateSuccess}
          onError={onError}
          UsersList={UsersList}
          id={leadDetail?.leadid}
          entitytype="lead"
          entityname={leadDetail?.name}
          followUpID={followUpID}
        />
      ),
      count: leadDetail?.schedules_count,
    },

    {
      key: "comments",
      label: "Comments",
      component: (
        <CommentsTab leadDetail={leadDetail} updateCount={updateCount} />
      ),
      count: leadDetail?.comments_count,
    },
    {
      key: "files",
      label: "Files",
      component: (
        <FilesTab
          leadId={leadDetail?.leadid}
          attachments={leadDetail?.attachments}
          attachmenttype="lead"
          updateCount={updateCount}
          data={leadDetail}
        />
      ),
      count: leadDetail?.attachments_count,
    },
  ].filter(Boolean);

  const [tab, setTab] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (condition2) {
      setTab(2);
    }
  }, []);

  const [tabsCustomizeTabs, setTabsCustomizeTabs] = useState({
    details: true,
    followups: true,
    timeline: true,
    comments: true,
    files: true,
  });

  const handleTabChange = (index) => {
    setTab(index || 0);
  };

  const renderedTabs = useMemo(() => {
    return TAB_CONFIG.map((tabItem, index) => {
      // if (!tabsCustomizeTabs[tabItem.key]) return null;
      if (tabItem.key !== "timeline" && !tabsCustomizeTabs[tabItem.key])
        return null;
      return (
        <TabButton
          key={tabItem.key}
          active={tab === index}
          label={tabItem.label}
          count={tabItem.count}
          onClick={() => {
            if (tabItem?.component) {
              handleTabChange(index);
              setDealCardOpen(false);
              setProjectCardOpen(false);
            }
            if (tabItem?.key == "timeline") {
              getData();
            }
          }}
        />
      );
    });
  }, [tab, tabsCustomizeTabs, leadDetail]);

  const [showAll, setShowAll] = useState(false);

  const users = Array.isArray(leadDetail?.assigned_user_details)
    ? leadDetail.assigned_user_details
    : [];

  const visibleUsers = showAll ? users : users.slice(0, 2);
  const hiddenCount = users.length - 3;

  const remainingUsers = useMemo(() => {
    if (productionUsers?.length == 0) return [];

    const assignedUserIds = new Set(users?.map((u) => u?.userid));

    return productionUsers?.filter(
      (user) => !assignedUserIds.has(user?.userid),
    );
  }, [users, productionUsers]);

  const filteredUsers = useMemo(() => {
    if (!search.trim()) return remainingUsers;

    return remainingUsers.filter((u) =>
      u.name.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, remainingUsers]);

  const addAssigned = async (user) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to assigned this agent?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      return;
    }

    let data = {
      lead_id: leadDetail?.leadid,
      agent_id: user?.userid,
    };

    try {
      const url = `leads/assign-agent-to-lead`;

      const apiRes = await apiCall({
        method: "post",
        url,
        data,
      });

      Swal.fire({
        icon: "success",
        title: apiRes?.message || "Assigned Agent Successfully",
        timer: 1500,
      });

      setShowDropdown(false);
      getData();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error?.response?.data?.respMsg ||
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Something went wrong",
      });
      setShowDropdown(false);
    }
  };

  const deleteAssigned = async (user) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to remove this Agent into assigned?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      return;
    }

    let data = {
      lead_id: leadDetail?.leadid,
      agent_id: user?.userid,
      type: "lead",
    };

    try {
      const url = `users/un-assign-agent-to-client`;

      const apiRes = await apiCall({
        method: "post",
        url,
        data,
      });

      Swal.fire({
        icon: "success",
        title: apiRes?.message || "UnAssigned Agent Successfully",
        timer: 1500,
      });

      setShowDropdown(false);
      setShowAll(false);
      getData();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error?.response?.data?.respMsg ||
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Something went wrong",
      });
      setShowDropdown(false);
    }
  };

  const menuRef = useRef(null);

  useClickOutside(menuRef, () => {
    showMenu(false);
  });

  const assignedRef = useRef(null);

  useClickOutside(assignedRef, () => {
    setShowAll(false);
  });

  const assignedDropdownRef = useRef(null);

  useClickOutside(assignedDropdownRef, () => {
    setShowDropdown(false);
  });
  return (
    <>
      {isLoading ? (
        <InnerLoader />
      ) : !leadDetail ? (
        <div className="flex justify-center items-center w-full h-full">
          <DataNotFound title={"Details"} />
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            height: "100vh",
            // fontFamily:
            //   "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
            background: T.bg,
            color: T.text,
            overflow: "hidden",
          }}
          className="innerPage"
        >
          <div
            style={{
              flex: 1,
              overflow: "auto",
              padding: "20px 0px 0px 0px",
              display: "flex",
              gap: 20,
            }}
          >
            {/* Middle Section */}

            <div
              style={{
                flex: 1,
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                gap: 16,
              }}
            >
              <div className="flex-1 min-w-0  flex flex-col gap-4">
                <Card style={{ padding: 0 }}>
                  {/* Contact bar */}
                  <div
                    style={{
                      padding: "20px 24px",
                      display: "flex",
                      alignItems: "center",
                      gap: 16,
                    }}
                  >
                    <Avatar
                      src={leadDetail?.userimg}
                      title={leadDetail?.name}
                      width="52px"
                      height="52px"
                      className={`!text-[#fff] !text-[18px] !font-bold !shrink-0 !bg-[linear-gradient(135deg,#6366f1,#8b5cf6)]`}
                    />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                        }}
                      >
                        <span
                          style={{
                            fontSize: 20,
                            fontWeight: 700,
                            color: T.text,
                          }}
                        >
                          {leadDetail?.name}
                        </span>
                        <div className="flex gap-1">
                          <span
                            className="inline-flex py-[4px] px-[12px] rounded-[6px] text-[10px] font-bold uppercase"
                            style={
                              LeadStatus[
                                leadDetail?.leadstatus?.toLowerCase()
                              ] || {
                                background: "#f5f5f5",
                                color: "#616161",
                              }
                            }
                          >
                            {leadDetail?.leadstatus}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: 16,
                          marginTop: 6,
                          flexWrap: "wrap",
                        }}
                      >
                        {[
                          {
                            icon: "phone",
                            text: leadDetail?.phone,
                            action: true,
                            phone: true,
                          },
                          {
                            icon: "mail",
                            text: leadDetail?.email,
                            action: true,
                            email: true,
                          },
                          { icon: "globe", text: leadDetail?.country || "-" },
                          { icon: "leadsource", text: leadDetail?.leadsource },
                        ].map((item, i) => (
                          <span
                            key={i}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 5,
                              fontSize: 12,
                              color: item.action ? T.accentText : T.textMuted,
                              cursor: item.action ? "pointer" : "default",
                            }}
                          >
                            <Icon
                              name={item.icon}
                              size={12}
                              color={item.action ? T.accentText : T.textMuted}
                            />
                            {item?.email || item?.phone ? (
                              <a
                                href={
                                  item?.email
                                    ? `mailto:${item.text}`
                                    : item?.phone
                                      ? `tel:${item.text}`
                                      : ""
                                }
                              >
                                {item.text}
                              </a>
                            ) : (
                              item.text
                            )}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <span style={{ fontSize: 12, color: T.textMuted }}>
                        Assigned
                      </span>
                      <div className="flex  gap-1 items-center">
                        <div className="relative " ref={assignedRef}>
                          <div
                            className="flex -space-x-2 cursor-pointer"
                            onClick={() => {
                              setShowAll(!showAll);
                              setShowDropdown(false);
                            }}
                          >
                            {leadDetail?.assigned_user_details
                              ?.slice(0, 3)
                              .map((user) => (
                                <>
                                  {/* <div
                                    style={{
                                      width: 34,
                                      height: 34,
                                      borderRadius: 100,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      background: "#6366f1" + "18",
                                      color: "#6366f1",
                                      fontSize: 12,
                                      fontWeight: 700,
                                      border: `2px solid #6366f130`,
                                    }}
                                  >
                                    {getInitials(user?.name)}
                                  </div> */}
                                  <Avatar
                                    src={user?.userimg}
                                    title={user?.name}
                                    width="34px"
                                    height="34px"
                                    className="border-2 !border-[#6366f130] !text-xs !font-bold !bg-[#6366f118] text-[#6366f1] shadow-sm "
                                  />
                                </>
                              ))}

                            {hiddenCount > 0 && (
                              <div className="h-9 w-9 flex items-center justify-center rounded-full bg-[#0057FB] text-white text-xs font-medium border-2 border-white shadow-sm">
                                +{hiddenCount}
                              </div>
                            )}
                          </div>

                          {showAll && (
                            <div className="absolute top-9   right-0 w-60 border border-[#f6f6f6]  bg-white rounded-xl shadow-xl p-3 z-30 overflow-hidden">
                              <div className="flex justify-between items-center mb-2  p-1 border-gray-400 border-b">
                                <h4 className="text-sm font-medium">
                                  Assigned Agents
                                </h4>
                                <button
                                  onClick={() => setShowAll(false)}
                                  className="p-1 rounded hover:bg-gray-100 transition"
                                >
                                  <X className="w-4 h-4 text-gray-500 hover:text-black" />
                                </button>
                              </div>

                              <div className="!overflow-y-auto w-full max-h-52  h-full">
                                {leadDetail?.assigned_user_details?.map(
                                  (each, idx) => (
                                    <div
                                      key={idx}
                                      className="flex items-center justify-between gap-2 p-1 hover:bg-slate-100 transition-all duration-300"
                                    >
                                      <AvatarProfile
                                        src={each?.userimg}
                                        title={each?.name}
                                        className="text-sm"
                                      />

                                      <span className="flex justify-end">
                                        <Tooltip
                                          key={`${idx}-unassigned`}
                                          className={`${Style.Tooltip}`}
                                          boxClassName={Style.TooltipBox}
                                          content="Delete"
                                          position={"bottom center"}
                                        >
                                          <div
                                            onClick={() => {
                                              deleteAssigned(each);
                                            }}
                                            className="p-2 text-red-600"
                                          >
                                            <Trash2 size={18} />
                                          </div>
                                        </Tooltip>
                                      </span>
                                    </div>
                                  ),
                                )}
                              </div>
                            </div>
                          )}
                        </div>

                        <div>
                          <div
                            className="projectDetail-cardLeftUserAddBtn selectUser relative"
                            ref={assignedDropdownRef}
                          >
                            <button
                              className="bg-[#0057FB] h-8 w-8 text-white flex justify-center text-[12px] p-1 rounded-full items-center gap-1 selectUser-btn cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowDropdown(!showDropdown);
                                setShowAll(false);
                              }}
                            >
                              {" "}
                              <Plus className="h-5 w-5" />
                            </button>

                            {showDropdown && (
                              <div className="selectUser-view customSearch mt-2 border border-[#f6f6f6] shadow-xl p-3 rounded-xl  bg-white w-64 absolute right-0  z-20">
                                <div className="selectUser-search flex items-center gap-2  mb-2 border-gray-400 border-b pb-1">
                                  <div className="icon">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                    >
                                      <mask
                                        id="mask1"
                                        style={{ maskType: "alpha" }}
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="18"
                                        height="18"
                                      >
                                        <rect
                                          width="18"
                                          height="18"
                                          fill="#D9D9D9"
                                        ></rect>
                                      </mask>
                                      <g mask="url(#mask1)">
                                        <path
                                          d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z"
                                          fill="#999999"
                                        ></path>
                                      </g>
                                    </svg>
                                  </div>
                                  <input
                                    type="text"
                                    placeholder="Search Agent..."
                                    className="customSearchInput border rounded px-2 py-1 w-full"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                  />
                                </div>

                                <div className="selectUser-list max-h-48 overflow-y-auto">
                                  <ul className="customSearchList ProjectAssignUsersList">
                                    {filteredUsers?.map((user) => (
                                      <li
                                        key={user?.userid}
                                        className="UserForAssign flex items-center gap-2 p-1 cursor-pointer hover:bg-gray-100 rounded"
                                        onClick={() => {
                                          addAssigned(user);
                                        }}
                                      >
                                        <AvatarProfile
                                          src={user?.userimg}
                                          title={user?.name}
                                          className="text-sm"
                                        />
                                      </li>
                                    ))}
                                    {loadingUsers && (
                                      <li className="p-2 text-center text-gray-400 text-sm">
                                        Loading...
                                      </li>
                                    )}
                                    {filteredUsers?.length == 0 && (
                                      <li className="p-1 text-gray-400">
                                        No users found
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: 12,
                }}
              >
                {leadDetail?.stats?.map((stat, i) => (
                  <Card key={i} style={{ padding: "14px 16px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontSize: 11,
                            color: T.textMuted,
                            fontWeight: 500,
                            marginBottom: 4,
                          }}
                        >
                          {stat.label}
                        </div>
                        <div
                          style={{
                            fontSize: 20,
                            fontWeight: 700,
                            color: stat.color,
                          }}
                        >
                          {stat.value}
                        </div>
                      </div>
                      <div
                        style={{
                          width: 38,
                          height: 38,
                          borderRadius: 10,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: stat.color + "10",
                        }}
                      >
                        <Icon name={stat.icon} size={18} color={stat.color} />
                      </div>
                    </div>
                  </Card>
                ))}
              </div>

              <>
                <Card
                  style={{
                    padding: "6px 8px",
                    display: "flex",
                    gap: 4,
                    flexWrap: "wrap",
                  }}
                >
                  {renderedTabs}
                </Card>

                <div className="flex flex-col  h-screen overflow-auto">
                  {TAB_CONFIG.map(
                    (tabItem, index) =>
                      // <div >
                      tab === index && (
                        <Suspense
                          key={tabItem?.key}
                          fallback={
                            <div className="tableDataLoader">
                              <div className="tableDataLoader-wrapper">
                                <div className="loader"></div>
                                <span>Data Load...</span>
                              </div>
                            </div>
                          }
                        >
                          {tabItem?.component}
                        </Suspense>
                      ),
                    // </div>
                  )}
                </div>
              </>
            </div>

            <div
              style={{
                width: 260,
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                gap: 14,
              }}
            >
              {/* QUICK ACTIONS */}
              <Card style={{ padding: 16 }}>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: T.textMuted,
                    letterSpacing: "1px",
                    marginBottom: 12,
                    textTransform: "uppercase",
                  }}
                >
                  Quick Actions
                </div>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  <ActionButton
                    icon="phone"
                    label="Log a Call"
                    color="#3b82f6"
                    variant="filled"
                    onClick={() => {
                      setLogType("call");
                      setShowLogModal(true);
                    }}
                  />
                  <ActionButton
                    icon="mail"
                    label="Send Email"
                    color="#8b5cf6"
                  />
                  <ActionButton icon="sms" label="Send SMS" color="#06b6d4" />
                  <ActionButton
                    icon="edit"
                    label="Edit Lead"
                    color="#3b82f6" // Blue
                    variant="60a5fa" // Hover / focus shade of blue
                    onClick={editLeadDetails}
                  />

                  <ActionButton
                    icon="power"
                    label="Convert to Deal"
                    color="#10b981" // Green
                    variant="34d399" // Hover / focus shade of green
                    onClick={ConvertDeal}
                  />
                  <ActionButton
                    icon="calendar"
                    label="Schedule Follow Up"
                    color="#f59e0b"
                    onClick={() => {
                      if (typeof setSelectedActivity === "function") {
                        setSelectedActivity(null);
                      }
                      if (typeof setShowActivityModal === "function") {
                        setShowActivityModal(true);
                      }
                      setMenuOpen(false);
                    }}
                  />
                </div>
              </Card>

              {/* UPCOMING */}

              {leadDetail?.next_schedules.length > 0 && (
                <Card style={{ padding: 16 }}>
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: T.textMuted,
                      letterSpacing: "1px",
                      marginBottom: 12,
                      textTransform: "uppercase",
                    }}
                  >
                    Next Up
                  </div>
                  <div className="w-full h-full max-h-24 overflow-auto ">
                    {leadDetail?.next_schedules
                      ?.filter((f) => f?.status === "pending")
                      // ?.slice(0, 2)
                      ?.map((f, i) => (
                        <div
                          key={f.id}
                          style={{
                            padding: "10px 4px",
                            borderBottom:
                              leadDetail?.next_schedules?.length - 1 > i
                                ? `1px solid ${T.cardBorder}`
                                : null,
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <div
                            style={{
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              background: priorityColors[f.priority],
                              boxShadow: `0 0 0 3px ${priorityColors[f.priority]}20`,
                            }}
                          />
                          <div>
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 600,
                                color: T.text,
                              }}
                            >
                              {f?.note}
                            </div>
                            <div style={{ fontSize: 11, color: T.textMuted }}>
                              {f?.due_date} · {f?.due_time}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </Card>
              )}
            </div>
          </div>
        </div>
      )}

      {showActivityModal && (
        // <EmployeeDirectoryAddUpdate
        //   onClose={() => {
        //     setShowActivityModal(false);
        //   }}
        //   data={null}
        //   tabIndex={2}
        //   onError={onError}
        //   onSubmit={updateSuccess}
        // id={leadDetail?.leadid}
        // entitytype="lead"
        // entityname={leadDetail.name}
        // />

        <FollowUpPopup
          onClose={() => {
            setShowActivityModal(false);
          }}
          CustomerData={null}
          tabIndex={2}
          onError={onError}
          onSubmit={updateSuccess}
          id={leadDetail?.leadid}
          entitytype="lead"
          entityname={leadDetail.name}
          UsersList={UsersList}
        />
      )}

      {showEditModal && (
        <EmployeeDirectoryAddUpdate
          onClose={() => {
            setShowEditModal(false);
            setCurrentData({});
          }}
          data={currentData}
          statusList={statusList}
          tabIndex={0}
          onError={updateError}
          onSubmit={updateSuccess}
        />
      )}

      {showConvertModal && (
        <ConvertLeadToDeal
          leadData={leadDetail}
          DealStages={DealStages}
          onClose={() => {
            setShowConvertModal(false);
          }}
          onError={onError}
          onSubmit={convertLeadSuccess}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>

      {show && (
        <CustomizeTabsOverviewPopup
          data={TAB_CONFIG.map((t) => t)}
          tabs={tabsCustomizeTabs}
          onClose={() => setShow(false)}
          onToggle={(tabName) => {
            if (tabName === "details") return; //
            setTabsCustomizeTabs((prev) => ({
              ...prev,
              [tabName]: !prev[tabName],
            }));
            handleTabChange(0);
          }}
        />
      )}
    </>
  );
}
